export enum FileUploaderErrorTypeEnum {
  /**Не валидное расширение */
  NoValidExtension = "no-valid-extension",
  /**Ошибка лимита на размер файла */
  LimitSize = "max-size",
}
